import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useEffect, useDebugValue, useCallback, useMemo } from 'react';
import { invalidateRequests } from '@applyboard/redux-bees';
import useReactRedux from "./useReactRedux";
import useGetRequestInfo from "./useGetRequestInfo";
var defaultDispatcher = function defaultDispatcher(call) {
  return call();
};
var defaultShouldMakeRequest = function defaultShouldMakeRequest(request) {
  return !request || !request.hasStarted;
};
var argumentsAbsorber = function argumentsAbsorber() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
var createMakeRequest = function createMakeRequest(dispatcher, apiCall) {
  if (typeof dispatcher === 'function') return dispatcher(apiCall);
  return apiCall(dispatcher);
};
var NOOP = function NOOP() {};
var useLazyLoad = function useLazyLoad(apiCall) {
  var dispatcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDispatcher;
  var shouldMakeRequest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultShouldMakeRequest;
  if (!apiCall) {
    throw new Error('useLazyLoad: cannot make call. apiCall parameter is required');
  }
  if (typeof dispatcher !== 'function' && _typeof(dispatcher) !== 'object' || Array.isArray(dispatcher)) {
    throw new TypeError('useLazyLoad: dispatcher must be either a function or an object');
  }
  var args = useMemo(function () {
    return typeof dispatcher === 'function' ? dispatcher(argumentsAbsorber, {
      apiCall: apiCall
    }) : [dispatcher];
  }, [dispatcher, apiCall]);
  var mapDispatchToProps = useCallback(function (dispatch) {
    return {
      makeRequest: function makeRequest() {
        return dispatch(createMakeRequest(dispatcher, apiCall));
      },
      invalidateRequest: function invalidateRequest(filters) {
        return dispatch(invalidateRequests(apiCall, filters));
      }
    };
  }, [apiCall, dispatcher]);
  var _useReactRedux = useReactRedux(NOOP, mapDispatchToProps),
    makeRequest = _useReactRedux.makeRequest,
    invalidateRequest = _useReactRedux.invalidateRequest;
  var request = useGetRequestInfo(apiCall, args);
  useEffect(function () {
    if (shouldMakeRequest(request)) {
      makeRequest();
    }
  }, [request]);
  useDebugValue(request);
  var response = request && request.result ? request.result : null;
  var reload = useCallback(function () {
    invalidateRequest();
    makeRequest();
  }, [invalidateRequest, makeRequest]);
  return [response, request, invalidateRequest, reload];
};
export default useLazyLoad;